import api from 'services/api'
import { SIGN_OUT_SUCCESS } from '../../constants'

const signOutSuccess = response => ({
  type: SIGN_OUT_SUCCESS,
  response,
})

const signOut = () => dispatch =>
  api.request('signOut').then((response) => {
    if (response.status !== 'ERROR') {
      dispatch(signOutSuccess(response))
    }
  })

export default signOut



// WEBPACK FOOTER //
// ./services/app-state/profile/actions/signOut/index.js